// import React from "react";
// import { Link } from "react-router-dom";
// import { useNavigate } from "react-router-dom";
// import { Container, Navbar, Nav, NavDropdown, Button } from "react-bootstrap";

// export default function Header() {
//   const navigate = useNavigate();
//   const navigateToLoginHandler = () => {
//     localStorage.setItem("login-from", "report");
//     navigate("/login");
//   };
//   return (
//     <header id="header" className="fixed-top">
//       <div
//         className="container d-flex align-items-center header-container"
//         style={{ marginLeft: "2em" }}
//       >
//         <Link to="/" className="logo me-auto">
//           <img
//             src="/images/RoofTopMeasurements_logo.png"
//             alt=""
//             className="img-fluid"
//           />
//         </Link>
//         <nav id="navbar" className="navbar order-last order-lg-0">
//           <ul>
//             <li>
//               <Link to="/reports" className="">
//                 Reports
//               </Link>
//             </li>
//             <li>
//               <Link className="" to="/faq">
//                 FAQs
//               </Link>
//             </li>
//             <li>
//               <Link className="" to="/about-us">
//                 About Us
//               </Link>
//             </li>
//             <li>
//               <Link className="" to="/contact-us">
//                 Contact Us
//               </Link>
//             </li>
//           </ul>
//           <i className="bi bi-list mobile-nav-toggle"></i>{" "}
//         </nav>
//         <Link
//           to="/signup"
//           className="topbar-btns"
//           style={{ marginBottom: "0.5em" }}
//         >
//           Sign Up
//         </Link>
//         <button
//           onClick={(e) => navigateToLoginHandler(e)}
//           className="topbar-btns"
//           style={{ marginBottom: "0.5em" }}
//         >
//           Log In
//         </button>
//       </div>
//     </header>

//     <header id="header" className="fixed-top ">
// <Navbar className="header-container" expand="lg">
//   <Container>
//     <Navbar.Brand href="/"> <img
//   src="/images/RoofTopMeasurements_logo.png"
//   alt=""
//   style={{maxHeight:"40px"}}
// /></Navbar.Brand>
// <Navbar.Toggle aria-controls="navbarResponsive" />
// <Navbar.Collapse id="navbarResponsive" className="d-flex justify-content-between custom-collapse">
//         <Nav className="ms-auto">
//           <Nav.Link href="/reports">Reports</Nav.Link>
//           <Nav.Link href="/faq">FAQs</Nav.Link>
//           <Nav.Link href="/about-us">About Us</Nav.Link>
//           <Nav.Link href="/contact-us">Contact Us</Nav.Link>
//           <Nav.Link href="/signup" >
//           <Button style={{backgroundColor:"#BAE5EC", borderRadius:"0px", border:"none"}}>Signup</Button></Nav.Link>
//           <Nav.Link href="/login" >
//          <Button style={{backgroundColor:"#BAE5EC", borderRadius:"0px",}}>Login</Button></Nav.Link>
//         </Nav>
//       </Navbar.Collapse>
//   </Container>
// </Navbar>
//   </header>
//   );
// }

// {
/* <div className="container d-flex align-items-center header-container" >
<Link to="/" className="logo me-auto">
  <img
    src="/images/RoofTopMeasurements_logo.png"
    alt=""
    className="img-fluid"
  />


</Link>
<nav id="navbar" className="navbar order-last order-lg-0">
  <ul>
    <li>
      <Link to="/reports" className="">
        Reports
      </Link>
    </li>
    <li>
      <Link className="" to="/faq">
        FAQs
      </Link>
    </li>
    <li>
      <Link className="" to="/about-us">
        About Us
      </Link>
    </li>
    <li>
      <Link className="" to="/contact-us">
        Contact Us
      </Link>
    </li>
  </ul>
  <i className="bi bi-list mobile-nav-toggle"></i>{" "}
</nav>
<Link to="/signup" className="topbar-btns" style={{marginBottom:"0.5em"}}>
  Sign Up
</Link>
<button onClick={(e)=>navigateToLoginHandler(e)} className="topbar-btns" style={{marginBottom:"0.5em"}}>
  Log In
</button>
</div> */
// }

// {
/* <header id="header" className="fixed-top ">
<Navbar className="header-container" expand="lg">
  <Container>
    <Navbar.Brand href="/"> <img
  src="/images/RoofTopMeasurements_logo.png"
  alt=""
  style={{maxHeight:"40px"}}
/></Navbar.Brand>
<Navbar.Toggle aria-controls="navbarResponsive" />
<Navbar.Collapse id="navbarResponsive" className="d-flex justify-content-between custom-collapse">
        <Nav className="ms-auto">
          <Nav.Link href="/reports">Reports</Nav.Link>
          <Nav.Link href="/faq">FAQs</Nav.Link>
          <Nav.Link href="/about-us">About Us</Nav.Link>
          <Nav.Link href="/contact-us">Contact Us</Nav.Link>
          <Nav.Link href="/signup" >
          <Button style={{backgroundColor:"#BAE5EC", borderRadius:"0px", border:"none"}}>Signup</Button></Nav.Link>
          <Nav.Link href="/login" >
         <Button style={{backgroundColor:"#BAE5EC", borderRadius:"0px",}}>Login</Button></Nav.Link>
        </Nav>
      </Navbar.Collapse>
  </Container>
</Navbar>
  </header> */
// }

import React, { useState, useEffect } from "react";
import { Navbar, Nav, Container, Offcanvas, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useScreenSize, useCustomScreen } from "../Utils";
const Header = () => {
  const [show, setShow] = useState(false);
  const { isAuthenticated, login, logout } = useAuth();
  const {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isXlScreen,
    isXxlScreen,
    is4kScreen,
  } = useScreenSize();
  const { isLandscape1024, isPortrait1024, isIpadProPortrait } =
    useCustomScreen();

  const navigate = useNavigate();

  const handleOpen = () => setShow(!show);
  const handleClose = () => setShow(false);

  const navigateToLoginHandler = (e) => {
    e.preventDefault();
    console.log("Login navigation triggered");
  };

  // console.log("context auth", isAuthenticated);

  return (
    <header>
      <Navbar
        expand="lg"
        className="shadow-sm fixed-top p-1 overflow-hidden"
        style={{
          backgroundColor: "#4e585a",
          padding: is4kScreen ? "1rem" : "0.5em",
        }}
      >
        <Container fluid className="gap-3">
          <Navbar.Brand as={Link} to="/" className="me-auto  col-sm-4 col-lg-3">
            <img
              src="/images/RoofTopMeasurements_logo.png"
              alt="Logo"
              className="img-fluid"
              style={{
                width: isIpadProPortrait
                  ? ""
                  : isLargeScreen && isLandscape1024
                  ? "4rem"
                  : isLargeScreen && isPortrait1024
                  ? "7rem"
                  : isXlScreen
                  ? "4rem"
                  : isXxlScreen
                  ? "4rem"
                  : is4kScreen
                  ? "8rem"
                  : "90px",
              }}
            />
          </Navbar.Brand>

          <Navbar.Toggle
            aria-controls="offcanvas-navbar"
            onClick={handleOpen}
            style={{ boxShadow: "none" }}
          />

          <Navbar.Offcanvas
            id="offcanvas-navbar"
            aria-labelledby="offcanvas-navbar-label"
            style={{ backgroundColor: "#4e585a" }}
            placement="end"
            className="custom-offcanvas overflow-hidden"
            show={show}
            onHide={handleClose}
          >
            <Offcanvas.Header
              onClick={handleClose}
              closeButton
            ></Offcanvas.Header>
            <Offcanvas.Body>
              <Nav
                className="ms-lg-5  gap-3 d-flex justify-content-between align-items-center"
                style={{ width: "100%" }}
              >
                <div
                  className={`${
                    is4kScreen
                      ? "d-flex flex-grow-1 justify-content-evenly "
                      : isXxlScreen
                      ? "d-flex flex-grow-1 justify-content-evenly "
                      : isXlScreen
                      ? "d-flex flex-grow-1 justify-content-evenly"
                      : isLargeScreen
                      ? "d-flex flex-grow-1 justify-content-evenly"
                      : isLargeScreen && isPortrait1024
                      ? "d-flex flex-grow-1 justify-content-evenly"
                      : isMediumScreen
                      ? ""
                      : ""
                  }`}
                >
                  {" "}
                  <Nav.Link
                    onClick={handleClose}
                    closeButton
                    as={Link}
                    to="/reports"
                    className="text-white"
                    style={{
                      fontSize: isIpadProPortrait
                        ? "1.6rem"
                        : isLargeScreen && isLandscape1024
                        ? "1rem"
                        : isLargeScreen && isPortrait1024
                        ? "1.3rem"
                        : isXlScreen
                        ? "1rem"
                        : isXxlScreen
                        ? "1.1rem"
                        : is4kScreen
                        ? "2rem"
                        : isMediumScreen
                        ? "1.4rem"
                        : "1rem",
                    }}
                  >
                    Reports
                  </Nav.Link>
                  <Nav.Link
                    onClick={handleClose}
                    as={Link}
                    to="/faq"
                    className="text-white"
                    style={{
                      fontSize: isIpadProPortrait
                        ? "1.6rem "
                        : isLargeScreen && isLandscape1024
                        ? "1rem"
                        : isLargeScreen && isPortrait1024
                        ? "1.3rem"
                        : isXlScreen
                        ? "1rem"
                        : isXxlScreen
                        ? "1.1rem"
                        : is4kScreen
                        ? "2rem"
                        : isMediumScreen
                        ? "1.4rem"
                        : "1rem",
                    }}
                  >
                    FAQs
                  </Nav.Link>
                  <Nav.Link
                    onClick={handleClose}
                    as={Link}
                    to="/about-us"
                    className="text-white"
                    style={{
                      fontSize: isIpadProPortrait
                        ? "1.6rem "
                        : isLargeScreen && isLandscape1024
                        ? "1rem"
                        : isLargeScreen && isPortrait1024
                        ? "1.3rem"
                        : isXlScreen
                        ? "1rem"
                        : isXxlScreen
                        ? "1.1rem"
                        : is4kScreen
                        ? "2rem"
                        : isMediumScreen
                        ? "1.4rem"
                        : "1rem",
                    }}
                  >
                    About Us
                  </Nav.Link>
                  <Nav.Link
                    onClick={handleClose}
                    as={Link}
                    to="/contact-us"
                    className="text-white"
                    style={{
                      fontSize: isIpadProPortrait
                        ? "1.6rem "
                        : isLargeScreen && isLandscape1024
                        ? "1rem"
                        : isLargeScreen && isPortrait1024
                        ? "1.3rem"
                        : isXlScreen
                        ? "1rem"
                        : isXxlScreen
                        ? "1.1rem"
                        : is4kScreen
                        ? "2rem"
                        : isMediumScreen
                        ? "1.4rem"
                        : "1rem",
                    }}
                  >
                    Contact Us
                  </Nav.Link>
                </div>
                <div
                  className={`${
                    is4kScreen
                      ? `d-flex gap-${is4kScreen ? "5" : "3"} `
                      : isXxlScreen
                      ? `d-flex gap-${is4kScreen ? "5" : "3"}`
                      : isXlScreen
                      ? `d-flex gap-${is4kScreen ? "5" : "3"}`
                      : isLargeScreen
                      ? `d-flex gap-${is4kScreen ? "5" : "3"}`
                      : isMediumScreen
                      ? `d-flex flex-column gap-4 justify-content-evenly`
                      : "d-flex flex-column gap-4 justify-content-evenly"
                  }`}
                >
                  {isAuthenticated ? (
                    <>
                      <Nav.Link
                        onClick={handleClose}
                        as={Link}
                        to="/profile/billing-info"
                        className="text-black  text-responsive"
                        style={{
                          backgroundColor: "#bae5ec",
                          minWidth: "100px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          fontSize: isIpadProPortrait
                            ? "1.6rem "
                            : isLargeScreen && isLandscape1024
                            ? "1rem"
                            : isLargeScreen && isPortrait1024
                            ? "1.3rem"
                            : isXlScreen
                            ? "1rem"
                            : isXxlScreen
                            ? "1.1rem"
                            : is4kScreen
                            ? "2rem"
                            : isMediumScreen
                            ? "1.4rem"
                            : "1rem",
                          paddingLeft: is4kScreen ? "3rem" : "",
                          paddingRight: is4kScreen ? "3rem" : "",
                        }}
                      >
                        Profile
                      </Nav.Link>
                      <Nav.Link
                        onClick={() => {
                          handleClose();
                          logout();
                        }}
                        as={Link}
                        to="/login"
                        className="text-dark"
                        style={{
                          backgroundColor: "#bae5ec",
                          minWidth: "100px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          fontSize: isIpadProPortrait
                            ? "1.6rem "
                            : isLargeScreen && isLandscape1024
                            ? "1rem"
                            : isLargeScreen && isPortrait1024
                            ? "1.3rem"
                            : isXlScreen
                            ? "1rem"
                            : isXxlScreen
                            ? "1.1rem"
                            : is4kScreen
                            ? "2rem"
                            : isMediumScreen
                            ? "1.4rem"
                            : "1rem",
                          paddingLeft: is4kScreen ? "3rem" : "",
                          paddingRight: is4kScreen ? "3rem" : "",
                        }}
                      >
                        Logout
                      </Nav.Link>
                    </>
                  ) : (
                    <Nav.Link
                      onClick={() => {
                        handleClose();
                        // login();
                      }}
                      as={Link}
                      to="/login"
                      className="text-dark  text-responsive"
                      style={{
                        backgroundColor: "#bae5ec",
                        minWidth: "100px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontSize: isIpadProPortrait
                          ? "1.6rem "
                          : isLargeScreen && isLandscape1024
                          ? "1rem"
                          : isLargeScreen && isPortrait1024
                          ? "1.3rem"
                          : isXlScreen
                          ? "1rem"
                          : isXxlScreen
                          ? "1.1rem"
                          : is4kScreen
                          ? "2rem"
                          : isMediumScreen
                          ? "1.4rem"
                          : "1rem",
                        paddingLeft: is4kScreen ? "3rem" : "",
                        paddingRight: is4kScreen ? "3rem" : "",
                      }}
                    >
                      Login
                    </Nav.Link>
                  )}

                  {!isAuthenticated && (
                    <Nav.Link
                      onClick={handleClose}
                      as={Link}
                      to="/signup"
                      className="text-black text-responsive"
                      style={{
                        backgroundColor: "#bae5ec",
                        minWidth: "100px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingLeft: is4kScreen ? "2rem" : "",
                        paddingRight: is4kScreen ? "1rem" : "",
                        fontSize: isIpadProPortrait
                          ? "1.6rem "
                          : isLargeScreen && isLandscape1024
                          ? "1rem"
                          : isLargeScreen && isPortrait1024
                          ? "1.3rem"
                          : isXlScreen
                          ? "1rem"
                          : isXxlScreen
                          ? "1.1rem"
                          : is4kScreen
                          ? "2rem"
                          : isMediumScreen
                          ? "1.4rem"
                          : "1rem",
                        paddingLeft: is4kScreen ? "3rem" : "",
                        paddingRight: is4kScreen ? "3rem" : "",
                      }}
                    >
                      Signup
                    </Nav.Link>
                  )}
                </div>
              </Nav>

              {/* Buttons */}
              {/* <div className="d-flex gap-3">
                <Button as={Link} to="/signup" variant="primary">
                  Sign Up
                </Button>
                <Button
                  variant="outline-light"
                  onClick={navigateToLoginHandler}
                >
                  Log In
                </Button>
              </div> */}
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
